import { filterDataProps, filterEventHandlerProps } from '@THC/utils/helpers';
export const useButton = (props) => {
    const { as = 'button', disabled, download, form, formAction, href, id, name, rel = 'noreferrer noopener', tabIndex, target, to, type = 'button', value, } = props;
    let customProps = {};
    if (as === 'button') {
        customProps = {
            disabled,
            form,
            formAction,
            name,
            tabIndex,
            type,
            value,
        };
    }
    else {
        customProps = {
            'aria-disabled': disabled || undefined,
            download,
            href: disabled ? undefined : href,
            rel,
            role: 'button',
            tabIndex: disabled ? undefined : tabIndex || 0,
            target,
            to,
        };
    }
    return {
        buttonProps: {
            ...customProps,
            ...filterDataProps(props),
            ...filterEventHandlerProps(props),
            'aria-controls': props['aria-controls'],
            'aria-current': props['aria-current'],
            'aria-describedby': props['aria-describedby'],
            'aria-expanded': props['aria-expanded'],
            'aria-haspopup': props['aria-haspopup'],
            'aria-hidden': props['aria-hidden'],
            'aria-label': props['aria-label'],
            'aria-labelledby': props['aria-labelledby'],
            'aria-pressed': props['aria-pressed'],
            id,
        },
    };
};
